export const cleanString = str => {
  return str
    ?.replace(/[-_.%20]/g, ' ') // заменяем разделители на пробелы
    ?.replace(/[^a-zA-Z0-9\s]/g, '') // оставляем только буквы, цифры и пробелы
    ?.trim()
    ?.split(' ')
    ?.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    ?.join(' ');
};
